
export default {
  name: 'ArrowUpTrend',
  props: {
    color: {
      type: String,
      default: '#0dd400',
    },
  },
};
